/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


angular
    .module('menuAllSites')
    .directive('menuSites', menuSites);
    
angular
    .module('menuAllSites')    
    .directive('imageonload', imageonload);  
    
    
    
    
    
function menuSites() {
    void 0;
    return {
        restrict: 'E',
        templateUrl: sessionStorage.plugindir+'menu.html'
    };
}

function imageonload() {
    
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.on('load', function() {
                // Set visibility: true + remove spinner overlay
                element.removeClass('spinner-hide');
                element.addClass('spinner-show');
                if(!element.parent().find('md-grid-tile-footer').hasClass('no-background')){
                    element.parent().find('md-grid-tile-footer').remove();
                }
                    element.parent().parent().parent().css('background-color','');
            });
            scope.$watch('ngSrc', function() {
                // Set visibility: false + inject temporary spinner overlay
                element.addClass('spinner-hide');
          });
        }
    };
}